import React from 'react'

import cn from '../../libs/class-names'
import {mapChildrenWithFragments} from '../../services/react-children'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
}

const CompactModelList = ({classNames, children}: Props) => (
  <div className={cn('CompactModelList', {}, classNames)}>{mapChildrenWithFragments(children)}</div>
)

export default CompactModelList
